/*
 * @Descripttion: 
 * @Author: wyx
 * @Date: 2020-09-09 14:56:57
 * @LastEditors: wyx
 * @LastEditTime: 2020-09-17 18:08:01
 */
import Vue from 'vue'
import Vuex from 'vuex'

import common from './common'
import home from './home'
import search from './search'
import audit from './audit'
import leader from './leader'
import notice from './notice'
import event from './event'
import material from './material'
import rss from './rss'
import user from './user'
import discover from './discover'
import statistics from './statistics'

Vue.use(Vuex)

const store = new Vuex.Store({
    modules: {
        common,
        home,
        search,
        audit,
        leader,
        notice,
        event,
        material,
        rss,
        user,
        discover,
        statistics
    }
})

export default store
